// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../.yarn/__virtual__/css-loader-virtual-12041de04e/0/cache/css-loader-npm-6.11.0-d945f9f4c0-bb52434138.zip/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../.yarn/__virtual__/css-loader-virtual-12041de04e/0/cache/css-loader-npm-6.11.0-d945f9f4c0-bb52434138.zip/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../.yarn/__virtual__/css-loader-virtual-12041de04e/0/cache/css-loader-npm-6.11.0-d945f9f4c0-bb52434138.zip/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("Exo-ExtraBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("Exo-ExtraBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("Exo-DemiBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("Exo-DemiBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("Exo-ExtraLight.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("Exo-ExtraLight.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("Exo-Black.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("Exo-Black.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("Exo-Bold-Italic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("Exo-Bold-Italic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("Exo-Black-Italic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("Exo-Black-Italic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("Exo-ExtraBold-Italic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("Exo-ExtraBold-Italic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("Exo-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("Exo-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("Exo-DemiBold-Italic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("Exo-DemiBold-Italic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("Exo-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("Exo-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("Exo-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("Exo-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("Exo-Regular-Italic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("Exo-Regular-Italic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("Exo-Thin.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("Exo-Thin.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("Exo-ExtraLight-Italic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("Exo-ExtraLight-Italic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("Exo-Medium-Italic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("Exo-Medium-Italic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("Exo-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("Exo-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("Exo-Light-Italic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("Exo-Light-Italic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("Exo-Thin-Italic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("Exo-Thin-Italic.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: 'Exo';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff');
    font-weight: bold;
    font-style: normal;
    font-display: fallback;
}

@font-face {
    font-family: 'Exo';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff');
    font-weight: 600;
    font-style: normal;
    font-display: fallback;
}

@font-face {
    font-family: 'Exo';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('woff');
    font-weight: 200;
    font-style: normal;
    font-display: fallback;
}

@font-face {
    font-family: 'Exo';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('woff');
    font-weight: 900;
    font-style: normal;
    font-display: fallback;
}

@font-face {
    font-family: 'Exo';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format('woff');
    font-weight: bold;
    font-style: italic;
    font-display: fallback;
}

@font-face {
    font-family: 'Exo';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format('woff');
    font-weight: 900;
    font-style: italic;
    font-display: fallback;
}

@font-face {
    font-family: 'Exo';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format('woff');
    font-weight: bold;
    font-style: italic;
    font-display: fallback;
}

@font-face {
    font-family: 'Exo';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format('woff');
    font-weight: bold;
    font-style: normal;
    font-display: fallback;
}

@font-face {
    font-family: 'Exo';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format('woff');
    font-weight: 600;
    font-style: italic;
    font-display: fallback;
}

@font-face {
    font-family: 'Exo';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_18___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format('woff');
    font-weight: 300;
    font-style: normal;
    font-display: fallback;
}

@font-face {
    font-family: 'Exo';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_20___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_21___}) format('woff');
    font-weight: 500;
    font-style: normal;
    font-display: fallback;
}

@font-face {
    font-family: 'Exo';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_22___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_23___}) format('woff');
    font-weight: normal;
    font-style: italic;
    font-display: fallback;
}

@font-face {
    font-family: 'Exo';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_24___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_25___}) format('woff');
    font-weight: 100;
    font-style: normal;
    font-display: fallback;
}

@font-face {
    font-family: 'Exo';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_26___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_27___}) format('woff');
    font-weight: 200;
    font-style: italic;
    font-display: fallback;
}

@font-face {
    font-family: 'Exo';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_28___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_29___}) format('woff');
    font-weight: 500;
    font-style: italic;
    font-display: fallback;
}

@font-face {
    font-family: 'Exo';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_30___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_31___}) format('woff');
    font-weight: normal;
    font-style: normal;
    font-display: fallback;
}

@font-face {
    font-family: 'Exo';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_32___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_33___}) format('woff');
    font-weight: 300;
    font-style: italic;
    font-display: fallback;
}

@font-face {
    font-family: 'Exo';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_34___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_35___}) format('woff');
    font-weight: 100;
    font-style: italic;
    font-display: fallback;
}

`, "",{"version":3,"sources":["webpack://./public/cp/media/fonts/exo/exofont.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB;8DAC4C;IAC5C,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB;8DAC2C;IAC3C,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB;8DAC6C;IAC7C,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB;8DACwC;IACxC,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB;8DAC8C;IAC9C,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB;+DAC+C;IAC/C,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB;+DACmD;IACnD,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB;+DACuC;IACvC,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB;+DACkD;IAClD,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB;+DACwC;IACxC,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB;+DACyC;IACzC,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB;+DACiD;IACjD,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB;+DACuC;IACvC,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB;+DACoD;IACpD,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB;+DACgD;IAChD,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB;+DAC0C;IAC1C,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB;+DAC+C;IAC/C,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB;+DAC8C;IAC9C,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;AAC1B","sourcesContent":["@font-face {\n    font-family: 'Exo';\n    src: url('Exo-ExtraBold.woff2') format('woff2'),\n        url('Exo-ExtraBold.woff') format('woff');\n    font-weight: bold;\n    font-style: normal;\n    font-display: fallback;\n}\n\n@font-face {\n    font-family: 'Exo';\n    src: url('Exo-DemiBold.woff2') format('woff2'),\n        url('Exo-DemiBold.woff') format('woff');\n    font-weight: 600;\n    font-style: normal;\n    font-display: fallback;\n}\n\n@font-face {\n    font-family: 'Exo';\n    src: url('Exo-ExtraLight.woff2') format('woff2'),\n        url('Exo-ExtraLight.woff') format('woff');\n    font-weight: 200;\n    font-style: normal;\n    font-display: fallback;\n}\n\n@font-face {\n    font-family: 'Exo';\n    src: url('Exo-Black.woff2') format('woff2'),\n        url('Exo-Black.woff') format('woff');\n    font-weight: 900;\n    font-style: normal;\n    font-display: fallback;\n}\n\n@font-face {\n    font-family: 'Exo';\n    src: url('Exo-Bold-Italic.woff2') format('woff2'),\n        url('Exo-Bold-Italic.woff') format('woff');\n    font-weight: bold;\n    font-style: italic;\n    font-display: fallback;\n}\n\n@font-face {\n    font-family: 'Exo';\n    src: url('Exo-Black-Italic.woff2') format('woff2'),\n        url('Exo-Black-Italic.woff') format('woff');\n    font-weight: 900;\n    font-style: italic;\n    font-display: fallback;\n}\n\n@font-face {\n    font-family: 'Exo';\n    src: url('Exo-ExtraBold-Italic.woff2') format('woff2'),\n        url('Exo-ExtraBold-Italic.woff') format('woff');\n    font-weight: bold;\n    font-style: italic;\n    font-display: fallback;\n}\n\n@font-face {\n    font-family: 'Exo';\n    src: url('Exo-Bold.woff2') format('woff2'),\n        url('Exo-Bold.woff') format('woff');\n    font-weight: bold;\n    font-style: normal;\n    font-display: fallback;\n}\n\n@font-face {\n    font-family: 'Exo';\n    src: url('Exo-DemiBold-Italic.woff2') format('woff2'),\n        url('Exo-DemiBold-Italic.woff') format('woff');\n    font-weight: 600;\n    font-style: italic;\n    font-display: fallback;\n}\n\n@font-face {\n    font-family: 'Exo';\n    src: url('Exo-Light.woff2') format('woff2'),\n        url('Exo-Light.woff') format('woff');\n    font-weight: 300;\n    font-style: normal;\n    font-display: fallback;\n}\n\n@font-face {\n    font-family: 'Exo';\n    src: url('Exo-Medium.woff2') format('woff2'),\n        url('Exo-Medium.woff') format('woff');\n    font-weight: 500;\n    font-style: normal;\n    font-display: fallback;\n}\n\n@font-face {\n    font-family: 'Exo';\n    src: url('Exo-Regular-Italic.woff2') format('woff2'),\n        url('Exo-Regular-Italic.woff') format('woff');\n    font-weight: normal;\n    font-style: italic;\n    font-display: fallback;\n}\n\n@font-face {\n    font-family: 'Exo';\n    src: url('Exo-Thin.woff2') format('woff2'),\n        url('Exo-Thin.woff') format('woff');\n    font-weight: 100;\n    font-style: normal;\n    font-display: fallback;\n}\n\n@font-face {\n    font-family: 'Exo';\n    src: url('Exo-ExtraLight-Italic.woff2') format('woff2'),\n        url('Exo-ExtraLight-Italic.woff') format('woff');\n    font-weight: 200;\n    font-style: italic;\n    font-display: fallback;\n}\n\n@font-face {\n    font-family: 'Exo';\n    src: url('Exo-Medium-Italic.woff2') format('woff2'),\n        url('Exo-Medium-Italic.woff') format('woff');\n    font-weight: 500;\n    font-style: italic;\n    font-display: fallback;\n}\n\n@font-face {\n    font-family: 'Exo';\n    src: url('Exo-Regular.woff2') format('woff2'),\n        url('Exo-Regular.woff') format('woff');\n    font-weight: normal;\n    font-style: normal;\n    font-display: fallback;\n}\n\n@font-face {\n    font-family: 'Exo';\n    src: url('Exo-Light-Italic.woff2') format('woff2'),\n        url('Exo-Light-Italic.woff') format('woff');\n    font-weight: 300;\n    font-style: italic;\n    font-display: fallback;\n}\n\n@font-face {\n    font-family: 'Exo';\n    src: url('Exo-Thin-Italic.woff2') format('woff2'),\n        url('Exo-Thin-Italic.woff') format('woff');\n    font-weight: 100;\n    font-style: italic;\n    font-display: fallback;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
